import { Engine } from '@rossum/api-client/engines';
import { Stack, Typography } from '@rossum/ui/material';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { AutomationBreadcrumbs } from '../../../containers/Automation/AutomationBreadcrumbs';
import { automationEnginesPath } from '../../../containers/Automation/helpers';
import CopyToClipboardButton from '../../../ui/copy-to-clipboard/CopyToClipboardButton';
import { Header, HeaderProps } from '../../../ui/header/Header';
import { basePath } from '../paths';
import { EngineSettingsTabs } from './EngineSettingsTabs';

type EngineQueueSettingsHeaderProps = {
  engine: Engine;
  isSaving: boolean;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const EngineQueueSettingsHeader = ({
  engine,
  isSaving,
  ...rest
}: EngineQueueSettingsHeaderProps) => {
  const intl = useIntl();

  const history = useHistory();

  return (
    <Header
      {...rest}
      breadcrumbs={
        <AutomationBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'components.appBar.menu.automation.aiEngines',
              }),
              to: automationEnginesPath(),
            },
            {
              label: engine.name,
            },
            {
              label: intl.formatMessage({
                id: 'features.engines.header.tabs.settings.queues',
              }),
            },
          ]}
        />
      }
      tabs={<EngineSettingsTabs value="queue-settings" engineId={engine.id} />}
      title={engine.name}
      description={
        <Stack sx={{ pt: 1 }}>
          <Typography variant="body2">
            {intl.formatMessage({
              id: 'features.engines.header.queueSettings.description',
            })}
          </Typography>
          <Stack direction="row" alignItems="center" gap={1}>
            <span>
              {intl.formatMessage({
                id: 'features.engines.header.description.engineId',
              })}
              {': '}
            </span>
            <Typography variant="body2" color="text.primary">
              {engine.agendaId}
            </Typography>
            <CopyToClipboardButton
              content={`${engine.agendaId}`}
              iconColor="secondary"
            />
          </Stack>
        </Stack>
      }
      onBackButtonClicked={() => history.push(basePath)}
    />
  );
};
